import React from 'react';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import clsx from 'clsx';
import ToolTip from 'core/components/Tooltip';

type Props = {
  label: string;
  infoTooltip: string;
  className?: string;
};

export default function FormWorkflowFieldLabel({
  label,
  infoTooltip,
  className,
}: Props) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 font-semibold text-xs text-gray-500 tracking-wide leading-none',
        className,
      )}
    >
      {label}
      <ToolTip title={infoTooltip}>
        <span className="inline-flex shrink-0 items-center leading-none">
          <HelpOutlineRoundedIcon className="!h-3.5 !w-3.5 text-gray-500" />
        </span>
      </ToolTip>
    </span>
  );
}
